import React from 'react';
import { useHistory } from 'react-router-dom';
import { EditOutlined } from '@mui/icons-material';
import style from '../style';

const { HeaderEditButton } = style;

/**
 * @typedef {Object} Props
 * @property {boolean} [visible=false] - Parametro para indicar si se muestra el botón o no.
 * @property {any[]} course - Información mal estructurada del curso.
 */

/**
 * Botón de edición de curso, solo se muestra si el curso es visto por el mismo usuario que lo creó.
 * @param {Props} props - Propiedades del componente.
 */
const CourseEditButton = ({ visible = false, course }) => {
  const history = useHistory();

  if (visible === false || !course) return null;

  return (
    <HeaderEditButton
      onClick={() => {
        history.push({
          pathname: '/cursos/editar',
          state: {
            update: true,
            course,
            isComingFrom: '/cursos/detalles',
          },
        });
      }}
    >
      <EditOutlined />
    </HeaderEditButton>
  );
};

export default CourseEditButton;
